import { Component, ComponentInterface, h, Host, JSX } from '@stencil/core';

/**
 * @slot - elements that should inherit this overlay context
 */
@Component({
  tag: 'wb-overlay-context',
  styleUrl: './overlay-context.scss',
  shadow: true,
})
export class OverLayContextComponent implements ComponentInterface {
  public render(): JSX.Element {
    return (
      <Host class="wb-overlay-context">
        <slot />
      </Host>
    );
  }
}
